import * as st from "lib/utils/socialtravel";
import InstallmentDecorator from "./InstallmentDecorator";

export default class OrderInstallmentDecorator extends InstallmentDecorator {
  static get transfer_type_options() {
    return [
      ["cash", I18n.humanAttributeName("order_installment", "cash")],
      ["online_payment", I18n.humanAttributeName("order_installment", "online_payment")],
      ["bank_wire", I18n.humanAttributeName("order_installment", "bank_wire")],
    ];
  }

  static get paid_by_types() {
    return [
      ["exact_date", I18n.humanAttributeName("order_installment", "exact_date")],
      [
        "x_days_after_previous_installment",
        I18n.humanAttributeName("order_installment", "x_days_after_previous_installment"),
      ],
      ["x_days_after_order_creation", I18n.humanAttributeName("order_installment", "x_days_after_order_creation")],
      [
        "x_days_after_order_company_approval",
        I18n.humanAttributeName("order_installment", "x_days_after_order_company_approval"),
      ],
      [
        "x_days_after_order_full_approval",
        I18n.humanAttributeName("order_installment", "x_days_after_order_full_approval"),
      ],
      ["x_days_before_stock_starts_at", I18n.humanAttributeName("order_installment", "x_days_before_stock_starts_at")],
      ["on_stock_starts_at", I18n.humanAttributeName("order_installment", "on_stock_starts_at")],
    ];
  }

  static build(data = {}) {
    return new this({
      id: null,
      uuid: st.generateUuid(),
      type: "OrderInstallment",
      ...data,
    });
  }

  get is_exact_amount() {
    return this.amount_type === "exact_amount";
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/OrderInstallmentDecorator.js